// extracted by mini-css-extract-plugin
export default {"searchResults":"SearchResults_searchResults__chBBB","placeholder":"SearchResults_placeholder__fhTA9"};